import { render, staticRenderFns } from "./UpdateVersionModal.vue?vue&type=template&id=41dcfcdf&"
import script from "./UpdateVersionModal.vue?vue&type=script&lang=js&"
export * from "./UpdateVersionModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateVersionModal.vue?vue&type=style&index=0&id=41dcfcdf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports